// tslint:disable
/**
 * AgoraPay API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AddParentRelationCommand } from '../models';
// @ts-ignore
import { MerchantDetailsDto } from '../models';
// @ts-ignore
import { ProblemDetails } from '../models';
// @ts-ignore
import { RelatedChildMerchantDto } from '../models';
// @ts-ignore
import { RelatedParentMerchantDto } from '../models';
/**
 * MerchantApi - axios parameter creator
 * @export
 */
export const MerchantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AddParentRelationCommand} addParentRelationCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantAddParent: async (addParentRelationCommand: AddParentRelationCommand, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'addParentRelationCommand' is not null or undefined
            if (addParentRelationCommand === null || addParentRelationCommand === undefined) {
                throw new RequiredError('addParentRelationCommand','Required parameter addParentRelationCommand was null or undefined when calling merchantAddParent.');
            }
            const localVarPath = `/api/v1/Merchant/parent`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof addParentRelationCommand !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(addParentRelationCommand !== undefined ? addParentRelationCommand : {}) : (addParentRelationCommand || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} relationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantDeleteParent: async (relationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'relationId' is not null or undefined
            if (relationId === null || relationId === undefined) {
                throw new RequiredError('relationId','Required parameter relationId was null or undefined when calling merchantDeleteParent.');
            }
            const localVarPath = `/api/v1/Merchant/parent/{relationId}`
                .replace(`{${"relationId"}}`, encodeURIComponent(String(relationId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling merchantGet.');
            }
            const localVarPath = `/api/v1/Merchant/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [currentMerchantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantGetAvailableParents: async (currentMerchantId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Merchant/availableparents`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (currentMerchantId !== undefined) {
                localVarQueryParameter['currentMerchantId'] = currentMerchantId;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [currentMerchantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantGetChildren: async (currentMerchantId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Merchant/children`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (currentMerchantId !== undefined) {
                localVarQueryParameter['currentMerchantId'] = currentMerchantId;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [currentMerchantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantGetParents: async (currentMerchantId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Merchant/parents`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (currentMerchantId !== undefined) {
                localVarQueryParameter['currentMerchantId'] = currentMerchantId;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MerchantApi - functional programming interface
 * @export
 */
export const MerchantApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AddParentRelationCommand} addParentRelationCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantAddParent(addParentRelationCommand: AddParentRelationCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await MerchantApiAxiosParamCreator(configuration).merchantAddParent(addParentRelationCommand, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} relationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantDeleteParent(relationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await MerchantApiAxiosParamCreator(configuration).merchantDeleteParent(relationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MerchantDetailsDto>> {
            const localVarAxiosArgs = await MerchantApiAxiosParamCreator(configuration).merchantGet(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} [currentMerchantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantGetAvailableParents(currentMerchantId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MerchantDetailsDto>>> {
            const localVarAxiosArgs = await MerchantApiAxiosParamCreator(configuration).merchantGetAvailableParents(currentMerchantId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} [currentMerchantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantGetChildren(currentMerchantId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RelatedChildMerchantDto>>> {
            const localVarAxiosArgs = await MerchantApiAxiosParamCreator(configuration).merchantGetChildren(currentMerchantId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} [currentMerchantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantGetParents(currentMerchantId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RelatedParentMerchantDto>>> {
            const localVarAxiosArgs = await MerchantApiAxiosParamCreator(configuration).merchantGetParents(currentMerchantId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * MerchantApi - factory interface
 * @export
 */
export const MerchantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {AddParentRelationCommand} addParentRelationCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantAddParent(addParentRelationCommand: AddParentRelationCommand, options?: any): AxiosPromise<number> {
            return MerchantApiFp(configuration).merchantAddParent(addParentRelationCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} relationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantDeleteParent(relationId: number, options?: any): AxiosPromise<void> {
            return MerchantApiFp(configuration).merchantDeleteParent(relationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantGet(id: number, options?: any): AxiosPromise<MerchantDetailsDto> {
            return MerchantApiFp(configuration).merchantGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [currentMerchantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantGetAvailableParents(currentMerchantId?: number, options?: any): AxiosPromise<Array<MerchantDetailsDto>> {
            return MerchantApiFp(configuration).merchantGetAvailableParents(currentMerchantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [currentMerchantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantGetChildren(currentMerchantId?: number, options?: any): AxiosPromise<Array<RelatedChildMerchantDto>> {
            return MerchantApiFp(configuration).merchantGetChildren(currentMerchantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [currentMerchantId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantGetParents(currentMerchantId?: number, options?: any): AxiosPromise<Array<RelatedParentMerchantDto>> {
            return MerchantApiFp(configuration).merchantGetParents(currentMerchantId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MerchantApi - object-oriented interface
 * @export
 * @class MerchantApi
 * @extends {BaseAPI}
 */
export class MerchantApi extends BaseAPI {
    /**
     * 
     * @param {AddParentRelationCommand} addParentRelationCommand 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantApi
     */
    public merchantAddParent(addParentRelationCommand: AddParentRelationCommand, options?: any) {
        return MerchantApiFp(this.configuration).merchantAddParent(addParentRelationCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} relationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantApi
     */
    public merchantDeleteParent(relationId: number, options?: any) {
        return MerchantApiFp(this.configuration).merchantDeleteParent(relationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantApi
     */
    public merchantGet(id: number, options?: any) {
        return MerchantApiFp(this.configuration).merchantGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [currentMerchantId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantApi
     */
    public merchantGetAvailableParents(currentMerchantId?: number, options?: any) {
        return MerchantApiFp(this.configuration).merchantGetAvailableParents(currentMerchantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [currentMerchantId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantApi
     */
    public merchantGetChildren(currentMerchantId?: number, options?: any) {
        return MerchantApiFp(this.configuration).merchantGetChildren(currentMerchantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [currentMerchantId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantApi
     */
    public merchantGetParents(currentMerchantId?: number, options?: any) {
        return MerchantApiFp(this.configuration).merchantGetParents(currentMerchantId, options).then((request) => request(this.axios, this.basePath));
    }

}
